import React, { useState } from "react";
import { motion } from "framer-motion";
import { Box } from "@mui/material";

const EnvelopeAnimation = ({ message = "Happy Valentine's Day, my love! ❤️" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hearts, setHearts] = useState([]);

  // Generate floating hearts when opening the envelope
  const handleOpen = () => {
    setIsOpen(!isOpen);

    if (!isOpen) {
      // Generate 10-20 hearts with random properties
      const newHearts = Array.from({ length: 20 }, (_, index) => ({
        id: index,
        x: Math.random() * 150 - 50, // Random horizontal spread
        y: Math.random() * -150 - 50, // Random upward movement
        scale: Math.random() * 0.5 + 0.5, // Random size
        rotate: Math.random() * 360, // Random rotation
        delay: Math.random() * 0.3, // Random delay
        opacity: Math.random() * 0.5 + 0.5, // Random starting opacity
      }));
      setHearts(newHearts);
    } else {
      setHearts([]); // Clear hearts when closing
    }
  };

  return (
    <Box
      onClick={handleOpen} // Toggle open/close
      sx={{
        position: "relative",
        width: 310,
        height: 200,
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Floating Hearts */}
      {hearts.map(({ id, x, y, scale, rotate, delay, opacity }) => (
        <motion.div
          key={id}
          initial={{ opacity, scale: 0.5 }}
          animate={{
            opacity: 0, // Fades out while moving
            x,
            y,
            scale,
            rotate
          }}
          transition={{
            duration: 4,
            delay,
            opacity: {
              delay: 3.6, // Delay opacity fade
            }
          }}
          style={{
            position: "absolute",
            fontSize: "20px",
            color: "#ff3e6c",
            zIndex: 1,
          }}
        >
          ❤️
        </motion.div>
      ))}

      {/* Love Letter (Card) Inside */}
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={isOpen ? { y: -140, opacity: 1 } : { y: 40, opacity: 0 }}
        transition={{ type: "spring", stiffness: 100, damping: 10 }}
        style={{
          position: "absolute",
          width: "90%",
          height: "80%",
          backgroundColor: "#fff0f6",
          borderRadius: "10px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontSize: "14px",
          padding: "10px",
          fontWeight: "bold",
        }}
      >
        {message}
      </motion.div>

      {/* Envelope Bottom Part */}
      <Box
        sx={{
          width: "100%",
          height: "70%",
          backgroundColor: "#ff6b81",
          position: "absolute",
          bottom: 0,
          borderRadius: "10px",
          zIndex: 2,
        }}
      />

      {/* Envelope Flap */}
      <motion.div
        initial={{ rotateX: 0 }}
        animate={isOpen ? { rotateX: 180 } : { rotateX: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          width: "100%",
          height: "50%",
          backgroundColor: "#ff4757",
          position: "absolute",
          top: 0,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          transformOrigin: "bottom",
          zIndex: 2,
        }}
      />
    </Box>
  );
};

export default EnvelopeAnimation;
